import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";
import { siteInfo } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading text-background-50 mb-4">
              羞羞歪歪漫画
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                首页
              </Link>
              <Link
                to="/category/all"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                全部漫画
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-foreground-400">
              邮箱：{siteInfo.email}
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 羞羞歪歪漫画 - 本站所有漫画资源仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}